import { render, staticRenderFns } from "./ShareProgramDialog.vue?vue&type=template&id=e454e4fa"
import script from "./ShareProgramDialog.vue?vue&type=script&lang=js"
export * from "./ShareProgramDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports